module.exports = __webpack_public_path__ + "img/blog-02.fafb5a27.jpg";